((window) => {
    const mapHandlesTrategy = {
        googleMap: null,
        dbJson: null,
        initGoogleMap(request) {
            this.googleMap = new googleMap(this.dbJson);
        },
        async ADDRESS(request) {
            return await this.googleMap.getModifiStoresFromAddress(request.address)
        },
        async LATLNG(request) {
            const { lat, lng } = request
            return await this.googleMap.getModifiStoresFromLatLng(lat, lng)
        },
        IP() {

        },
        httpRequestData(request) {
            if (!this.googleMap) {
                this.initGoogleMap()
            }
            return this[request['type'].toUpperCase()](request)
        }
    }
    window.mapHandle = mapHandlesTrategy
})(window)


